import { keys, reduce, intersection, keyBy, cloneDeep, findIndex,
  indexOf, difference, map, union,
  uniq, each, filter, values, groupBy,
} from 'lodash';
import moment from 'moment';
import {
  WINLOSS_LOAD_OPPORTUNITIES,
  WINLOSS_UPDATE_OPPORTUNITY,
  WINLOSS_RESET,
  WINLOSS_SELECT_OPPORTUNITY,
  WINLOSS_UNSELECT_OPPORTUNITY,
  WINLOSS_TOGGLE_ALL,
  WINLOSS_EDIT_OPPORTUNITY,
  WINLOSS_EDIT_OPPORTUNITY_SELECT_CONTACTS,
  WINLOSS_EDIT_OPPORTUNITY_EDIT_CONTACT,
  WINLOSS_EDIT_OPPORTUNITY_UPDATE_CONTACT,
  WINLOSS_LOAD_TRACKINGS,
  WINLOSS_SUBMIT_SAMPLES,
  WINLOSS_LOAD_CONTACT_DISPOSITIONS,
  WINLOSS_FETCH_SAVED_PARAMS,
  WINLOSS_ADD_SAVED_PARAMS,
  WINLOSS_REMOVE_SAVED_PARAMS,
  WINLOSS_RESET_SELECTED_OPPORTUNITIES,
  WINLOSS_FETCH_UNLINKED_CONTACTS,
  WINLOSS_FETCH_SUBMITTED_PARAMS,
  WINLOSS_MASS_FETCH_OPPORTUNITY_CONTACTS,
} from './WinLossActions';
import { NOMINATION_LOAD_CLIENT_INITIATIVES } from './NominationActions';
import { DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_REQUESTED_FEEDBACK } from '../Dashboard/DashboardActions';


export const MASTER_CHECKBOX_STATUS = {
  none: 'none',
  full: 'full',
  partial: 'partial',
};

function selectOpportunity(opportunity, indexedContacts = {}, savedOpportunities = {}, tvProductMappings = {}) {
  const selectedContacts = [];
  const savedOpportunity = savedOpportunities[opportunity.opportunity_id] || {};
  const { tracking } = opportunity;
  const submmittedIds = tracking ? map(tracking.contacts, 'sfa__contactId') : [];
  if (opportunity.contact_roles) {
    const uniqRoles = values(keyBy(opportunity.contact_roles, 'contact_id'));
    uniqRoles.map((contactRole) => {
      if (indexedContacts[contactRole.contact_id] && indexOf(submmittedIds, contactRole.contact_id) < 0) {
        selectedContacts.push({
          ...indexedContacts[contactRole.contact_id],
        });
      }
      return contactRole;
    });
  }
  let selectedProductId = null;
  
  const selectedProductIds = [];
  if (opportunity.line_items) {
    if (opportunity.line_items.length === 1) {
      selectedProductId = opportunity.line_items[0].product_id;
    }
    each(opportunity.line_items, (lineItem) => {
      each(tvProductMappings[lineItem.product_id], (tvProductId) => {
        selectedProductIds.push(tvProductId);
      });
    });
  }

  // if tracking is available, and remove contacts that were submmitted from saved params
  if (tracking && savedOpportunity.selected_contacts) {
    savedOpportunity.selected_contacts = reduce(savedOpportunity.selected_contacts, (contacts, contact) => {
      if (indexOf(submmittedIds, contact.contact_id) < 0) {
        contacts.push(contact);
      }
      return contacts;
    }, []);
  }


  return {
    ...opportunity,
    selected_product_id: selectedProductId,
    selected_product_ids: selectedProductIds,
    selected_contacts: selectedContacts,
    ...savedOpportunity,
    account: {
      ...(opportunity.account || {}),
      ...(savedOpportunity.account || {}),
    },
  };
}

// Initial State
const initialState = {
  opportunities: {
    opportunities: [],
    indexedOpportunities: {},
    indexedContacts: {},
    status: null,
    errors: null,
  },
  winLoss: {},
  contacts: {}, // submitted contacts
  winLossEditingOpportunity: null,
  winLossTrackings: {
    trackings: {}, // indexed
    status: null,
    errors: null,
  },
  savedParams: {
    opportunities: {}, // indexed
    total: 0,
    status: null,
    errors: null,
  },
  submittedParams: {
    opportunities: {}, // indexed
    total: 0,
    status: null,
    errors: null,
  },
  unlinkedContacts: {
    contacts: [],
    status: null,
    errors: null,
  },
};
const WinLossReducer = (state = initialState, action) => {
  switch (action.type) {
    case NOMINATION_LOAD_CLIENT_INITIATIVES: {
      const { winLoss } = state;
      const newWinLoss = reduce(winLoss, (results, opportunity) => {
        results[opportunity.opportunity_id] = {
          ...opportunity,
          selected_contacts: reduce(opportunity.selected_contacts, (contacts, contact) => {
            contacts.push({
              ...contact, tags: [], buyer_type: null, buyer_role: null,
            });
            return contacts;
          }, []),
        };
        // todo: reset products
        return results;
      }, {});
      return { ...state, winLoss: newWinLoss };
    }
    case WINLOSS_SUBMIT_SAMPLES: {
      const results = {};
      action.addedSample.map((sample) => {
        if (!results[sample.opportunityId]) {
          results[sample.opportunityId] = [];
        }
        results[sample.opportunityId].push(sample.contactId);
        return sample;
      });
      const { winLoss } = state;
      const newWinLoss = reduce(winLoss, (opportunities, opportunity, opportunityId) => {
        const submittedContactIds = results[opportunityId];
        if (submittedContactIds) {
          const newSelectedContacts = reduce(opportunity.selected_contacts, (selectedContacts, contact) => {
            if (indexOf(submittedContactIds, contact.contact_id) < 0) {
              selectedContacts.push(contact);
            }
            return selectedContacts;
          }, []);
          if (newSelectedContacts.length > 0) {
            opportunities[opportunityId] = { ...opportunity, selected_contacts: newSelectedContacts };
          }
        } else {
          opportunities[opportunityId] = opportunity;
        }
        return opportunities;
      }, {});
      return { ...state, winLoss: newWinLoss };
    }
    case WINLOSS_LOAD_OPPORTUNITIES: {
      return {
        ...state,
        opportunities: {
          opportunities: action.opportunities,
          indexedOpportunities: keyBy(action.opportunities, 'opportunity_id'), // pointer, shadow copies
          indexedContacts: action.indexedContacts,
          status: action.status,
          errors: action.errors,
        },
      };
    }
    case WINLOSS_LOAD_CONTACT_DISPOSITIONS: {
      const { opportunities } = state;
      const {
        status, activities, errors, opportunityId, contactId,
      } = action;
      const newOpportunities = opportunities.opportunities.map((opportunity) => {
        const { tracking } = opportunity;
        if (tracking && opportunityId === tracking.tv__opportunityId) {
          const newContacts = tracking.contacts.map((contact) => {
            if (contactId && contact.tv__contactId) {
              return { ...contact, activities: { activities, errors, status } };
            }
            return contact;
          });
          return { ...opportunity, tracking: { ...tracking, contacts: newContacts } };
        }
        return opportunity;
      });
      const newIndexedOpportunities = keyBy(newOpportunities, 'opportunity_id');
      return { ...state, opportunities: { ...opportunities, opportunities: newOpportunities, indexedOpportunities: newIndexedOpportunities } };
    }
    case WINLOSS_LOAD_TRACKINGS: {
      const { trackings } = action;
      const loaded = action.status === 'loaded';
      /*
      TODO:
        opportunities: {
          opportunities: [], // update trackings
          indexedOpportunities: {},
          indexedContacts: {},
          status: null,
          errors: null,
        },
        winLoss: {},  // remove if not compatible
        winLossEditingOpportunity: null,
      */
      const { opportunities, winLoss } = state;
      const { indexedContacts } = opportunities;
      const hashedTrackings = {};
      const submmitedContacts = [];
      const newOpportunities = opportunities.opportunities.map((opportunity) => {
        let tracking = trackings[opportunity.opportunity_id];
        let submitted = false;
        if (tracking) {
          const { account } = opportunity;
          each(tracking.contacts, (submittedContact) => {
            if (indexedContacts[submittedContact.sfa__contactId]) {
              const sfContact = indexedContacts[submittedContact.sfa__contactId];
              submmitedContacts.push({
                ...sfContact,
                opportunity,
                account,
                ...submittedContact,
              });
            }
          });
          const nonRejectedContacts = filter(tracking.contacts, { rejected: false });
          const rejectedContactIds = map(filter(tracking.contacts, { rejected: true }), 'sfa__contactId');
          const submittedContactIds = map(nonRejectedContacts, 'sfa__contactId');

          // const oppContactIds = map(contacts || [], 'contact_id');
          // const accContactIds = map(account && account.contacts ? account.contacts : [], 'contact_id');
          // const allContactIds = union(oppContactIds, accContactIds);
          // const allSubmitted = difference(allContactIds, submittedContactIds).length === 0;
          const allSubmitted = false; // we don't load contacts on search, so we don't know

          tracking.submittedContactIds = submittedContactIds;
          tracking.allSubmitted = allSubmitted;
          tracking.rejectedContactIds = rejectedContactIds;
          submitted = tracking.submitted || allSubmitted;
          let lastActivity = null;
          each(nonRejectedContacts, (contact) => {
            if (contact.lastActivity) {
              const current = moment(contact.lastActivity.completed);
              if (!lastActivity || lastActivity.completed.isBefore(current)) {
                lastActivity = { ...contact.lastActivity, completed: current };
              }
            }
          });
          tracking.lastActivity = lastActivity;
        } else if (loaded) {
          tracking = {};
        }
        hashedTrackings[opportunity.opportunity_id] = tracking;
        return { ...opportunity, submitted, tracking };
      });
      const newIndexedOpportunities = keyBy(newOpportunities, 'opportunity_id');

      const newWinLoss = reduce(winLoss, (results, opportunity) => {
        results[opportunity.opportunity_id] = { ...opportunity, tracking: hashedTrackings[opportunity.opportunity_id] };
        return results;
      }, {});

      return {
        ...state,
        winLossTrackings: {
          trackings: action.trackings,
          status: action.status,
          errors: action.errors,
        },
        opportunities: {
          ...opportunities,
          opportunities: newOpportunities,
          indexedOpportunities: newIndexedOpportunities,
        },
        contacts: submmitedContacts,
        winLossEditingOpportunity: null, // to simplyfy things
        winLoss: newWinLoss,
      };
    }
    case WINLOSS_UPDATE_OPPORTUNITY: {
      const { winLoss } = state;
      const selected = winLoss[action.opportunityId] || {};
      const newParams = cloneDeep({ ...selected, ...action.params });
      return { ...state, winLoss: { ...winLoss, [action.opportunityId]: newParams } };
    }
    case WINLOSS_RESET: {
      return {
        ...state, contacts: {}, winLoss: {}, winLossEditingOpportunity: null,
      };
    }
    case WINLOSS_RESET_SELECTED_OPPORTUNITIES: {
      return {
        ...state, winLoss: {}, winLossEditingOpportunity: null,
      };
    }
    case WINLOSS_SELECT_OPPORTUNITY: {
      const { winLoss, opportunities, savedParams } = state;
      const selected = winLoss[action.opportunity.opportunity_id];
      if (!selected) {
        const opp = opportunities.indexedOpportunities[action.opportunity.opportunity_id] || action.opportunity;
        const newParams = selectOpportunity(opp, opportunities.indexedContacts, savedParams.opportunities, action.tvProductMappings);
        winLoss[action.opportunity.opportunity_id] = newParams;
        return state;
      }
      return state;
    }
    case WINLOSS_EDIT_OPPORTUNITY: {
      const { winLossEditingOpportunity } = state;
      if (winLossEditingOpportunity && winLossEditingOpportunity.opportunity_id === action.opportunity.opportunity_id) {
        return { ...state, winLossEditingOpportunity: null };
      }
      return { ...state, winLossEditingOpportunity: cloneDeep(action.opportunity) };
    }
    case WINLOSS_UNSELECT_OPPORTUNITY: {
      const { winLoss, winLossEditingOpportunity } = state;
      const newWinLoss = winLoss;
      delete newWinLoss[action.opportunity.opportunity_id];
      let newWinLossEditingOpportunity = winLossEditingOpportunity;
      if (winLossEditingOpportunity) {
        if (winLossEditingOpportunity.opportunity_id === action.opportunity.opportunity_id) {
          newWinLossEditingOpportunity = null;
        }
      }
      // const p = { ...state, winLoss: newWinLoss, winLossEditingOpportunity: newWinLossEditingOpportunity };
      const p = state;
      p.winLoss = newWinLoss;
      p.winLossEditingOpportunity = newWinLossEditingOpportunity;
      return p;
    }
    case WINLOSS_EDIT_OPPORTUNITY_EDIT_CONTACT: {
      const { winLossEditingOpportunity } = state;
      if (winLossEditingOpportunity) {
        if (action.contact) {
          const selectedContacts = winLossEditingOpportunity.selected_contacts;
          if (selectedContacts) {
            const idx = findIndex(selectedContacts, { contact_id: action.contact.contact_id });
            if (idx >= 0) {
              return { ...state, winLossEditingOpportunity: { ...winLossEditingOpportunity, editingContact: { ...action.contact } } };
            }
          }
        } else {
          return { ...state, winLossEditingOpportunity: { ...winLossEditingOpportunity, editingContact: null } };
        }
      }
      return state;
    }
    case WINLOSS_EDIT_OPPORTUNITY_UPDATE_CONTACT: {
      const { winLossEditingOpportunity } = state;
      if (winLossEditingOpportunity) {
        const selectedContacts = winLossEditingOpportunity.selected_contacts;
        if (selectedContacts) {
          let newSelectedContacts = selectedContacts;
          const idx = findIndex(selectedContacts, { contact_id: action.contact.contact_id });
          if (idx >= 0) {
            newSelectedContacts = [...selectedContacts];
            newSelectedContacts[idx] = { ...action.contact };
          }

          let opportunityContacts = winLossEditingOpportunity.contacts || [];
          const oIdx = findIndex(opportunityContacts, { contact_id: action.contact.contact_id });
          if (oIdx >= 0) {
            opportunityContacts = [...opportunityContacts];
            opportunityContacts[oIdx] = { ...action.contact };
          }

          let { account } = winLossEditingOpportunity;
          if (account) {
            let accountContacts = account.contacts || [];
            const aIdx = findIndex(accountContacts, { contact_id: action.contact.contact_id });
            if (aIdx >= 0) {
              accountContacts = [...accountContacts];
              accountContacts[aIdx] = { ...action.contact };
            }
            account = {
              ...account,
              contacts: accountContacts,
            };
          }

          return {
            ...state,
            winLossEditingOpportunity: {
              ...winLossEditingOpportunity,
              selected_contacts: newSelectedContacts,
              contacts: opportunityContacts,
              account,
            },
          };
        }
      }
      return state;
    }
    case WINLOSS_EDIT_OPPORTUNITY_SELECT_CONTACTS: {
      const { winLossEditingOpportunity } = state;
      const requestedContacts = action.contacts || [];
      if (winLossEditingOpportunity) {
        const { contacts, account } = winLossEditingOpportunity;
        const selectedContacts = winLossEditingOpportunity.selected_contacts;
        
        const accountIndexedContacts = account.indexedContacts || {};
        const opportunityIndexedContacts = keyBy(contacts, 'contact_id');
        const indexedSelectedContacts = keyBy(selectedContacts, 'contact_id');
        const availableContacts = { ...accountIndexedContacts, ...opportunityIndexedContacts };
        const newSelectedContacts = reduce(requestedContacts, (results, contact) => {
          if (availableContacts[contact.contact_id]) {
            if (indexedSelectedContacts[contact.contact_id]) {
              results.push(indexedSelectedContacts[contact.contact_id]);
            } else {
              results.push(contact);
            }
          }
          return results;
        }, []);
        return { ...state, winLossEditingOpportunity: { ...winLossEditingOpportunity, selected_contacts: newSelectedContacts } };
      }
      return state;
    }

    case WINLOSS_TOGGLE_ALL: {
      const { savedOnly, tvProductMappings } = action;
      const {
        winLoss, opportunities, winLossEditingOpportunity,
        savedParams,
      } = state;

      let selectedIds = [];
      let availableOpportunities = {};
      if (savedOnly) {
        const savedOpportunities = savedParams ? savedParams.opportunities : {};
        selectedIds = reduce(winLoss, (items, wl, oId) => {
          if (savedOpportunities[oId]) {
            items.push(oId);
          }
          return items;
        }, []);
        availableOpportunities = reduce(opportunities.indexedOpportunities, (items, opportunity, oId) => {
          if (savedOpportunities[oId]) {
            items[oId] = opportunity;
          }
          return items;
        }, {});
      } else {
        selectedIds = keys(winLoss);
        availableOpportunities = opportunities.indexedOpportunities;
      }

      const availableIds = keys(availableOpportunities);
      const validSelectedIds = intersection(selectedIds, availableIds);
      let newWinLoss = winLoss;
      let editingOpportunity = winLossEditingOpportunity;

      if (validSelectedIds.length < availableIds.length) {
        // should select all
        newWinLoss = reduce(availableIds, (results, id) => {
          if (winLoss[id]) {
            results[id] = winLoss[id];
          } else {
            results[id] = selectOpportunity(availableOpportunities[id], opportunities.indexedContacts, savedParams.opportunities, tvProductMappings);
          }
          return results;
        }, {});
      } else {
        // should UNselecte all
        newWinLoss = {};
        editingOpportunity = null;
      }
      return { ...state, winLoss: newWinLoss, winLossEditingOpportunity: editingOpportunity };
    }
    case WINLOSS_FETCH_SAVED_PARAMS: {
      const { opportunities, status, errors } = action;
      const indexedOpportunities = reduce(opportunities, (items, opportunity) => {
        items[opportunity.opportunity_id] = opportunity;
        return items;
      }, {});

      const allOpportunities = reduce(state.opportunities.opportunities, (items, opportunity) => {
        opportunity.is_saved = indexedOpportunities[opportunity.opportunity_id] !== undefined;
        items.push(opportunity);
        return items;
      }, []);
      const newWinLossOpportunities = reduce(state.winLoss, (items, opportunity) => {
        opportunity.is_saved = indexedOpportunities[opportunity.opportunity_id] !== undefined;
        items[opportunity.opportunity_id] = opportunity;
        return items;
      }, {});
      return {
        ...state,
        opportunities: {
          ...state.opportunities,
          opportunities: allOpportunities,
          indexedOpportunities: keyBy(allOpportunities, 'opportunity_id'),
        },
        winLoss: newWinLossOpportunities,
        savedParams: {
          opportunities: indexedOpportunities,
          total: opportunities.length,
          status,
          errors,
        },
      };
    }
    case WINLOSS_FETCH_SUBMITTED_PARAMS: {
      const { opportunities, status, errors } = action;
      const indexedOpportunities = reduce(opportunities, (items, opportunity) => {
        if (!items[opportunity.opportunity_id]) {
          items[opportunity.opportunity_id] = [];
        }
        items[opportunity.opportunity_id].push(opportunity);
        return items;
      }, {});

      const allOpportunities = reduce(state.opportunities.opportunities, (items, opportunity) => {
        opportunity.has_submitted_data = indexedOpportunities[opportunity.opportunity_id] !== undefined;
        items.push(opportunity);
        return items;
      }, []);
      const newWinLossOpportunities = reduce(state.winLoss, (items, opportunity) => {
        opportunity.has_submitted_data = indexedOpportunities[opportunity.opportunity_id] !== undefined;
        items[opportunity.opportunity_id] = opportunity;
        return items;
      }, {});
      return {
        ...state,
        opportunities: {
          ...state.opportunities,
          opportunities: allOpportunities,
          indexedOpportunities: keyBy(allOpportunities, 'opportunity_id'),
        },
        winLoss: newWinLossOpportunities,
        submittedParams: {
          opportunities: indexedOpportunities,
          total: opportunities.length,
          status,
          errors,
        },
      };
    }
    case WINLOSS_ADD_SAVED_PARAMS: {
      const { opportunities } = action;
      const newOpportunities = {
        ...state.savedParams.opportunities,
      };
      each(opportunities, (opportunity) => {
        const id = opportunity.opportunity_id;
        newOpportunities[id] = opportunity;
      });
      const allOpportunities = reduce(state.opportunities.opportunities, (items, opportunity) => {
        opportunity.is_saved = newOpportunities[opportunity.opportunity_id] !== undefined;
        items.push(opportunity);
        return items;
      }, []);
      const newWinLossOpportunities = reduce(state.winLoss, (items, opportunity) => {
        opportunity.is_saved = newOpportunities[opportunity.opportunity_id] !== undefined;
        items[opportunity.opportunity_id] = opportunity;
        return items;
      }, {});

      const total = values(newOpportunities).length;
      return {
        ...state,
        opportunities: {
          ...state.opportunities,
          opportunities: allOpportunities,
          indexedOpportunities: keyBy(allOpportunities, 'opportunity_id'),
        },
        winLoss: newWinLossOpportunities,
        savedParams: {
          ...state.savedParams,
          total,
          opportunities: newOpportunities, // indexed
        },
      };
    }
    case WINLOSS_REMOVE_SAVED_PARAMS: {
      const { ids } = action;

      const newOpportunities = {
        ...state.savedParams.opportunities,
      };

      each(ids, (id) => {
        delete newOpportunities[id];
      });
      
      const allOpportunities = reduce(state.opportunities.opportunities, (items, opportunity) => {
        opportunity.is_saved = newOpportunities[opportunity.opportunity_id] !== undefined;
        items.push(opportunity);
        return items;
      }, []);

      const newWinLossOpportunities = reduce(state.winLoss, (items, opportunity) => {
        opportunity.is_saved = newOpportunities[opportunity.opportunity_id] !== undefined;
        if (newOpportunities[opportunity.opportunity_id] !== undefined) {
          items[opportunity.opportunity_id] = opportunity;
        }
        return items;
      }, {});

      const total = values(newOpportunities).length;

      return {
        ...state,
        opportunities: {
          ...state.opportunities,
          opportunities: allOpportunities,
          indexedOpportunities: keyBy(allOpportunities, 'opportunity_id'),
        },
        winLoss: newWinLossOpportunities,
        savedParams: {
          ...state.savedParams,
          total,
          opportunities: newOpportunities, // indexed
        },
      };
    }
    case WINLOSS_FETCH_UNLINKED_CONTACTS: {
      const { contacts, status, errors } = action;
      return {
        ...state,
        unlinkedContacts: {
          contacts, status, errors,
        },
      };
    }
    case WINLOSS_MASS_FETCH_OPPORTUNITY_CONTACTS: {
      const {
        contacts, opportunityIds, status, accounts,
      } = action;

      const indexedAccounts = keyBy(accounts, 'account_id');
      const indexedByAccountId = groupBy(contacts, 'account_id');
      const indexedByContactId = keyBy(contacts, 'contact_id');

      const targetOpportunties = filter(state.opportunities.opportunities, opportunity => indexOf(opportunityIds, opportunity.opportunity_id) >= 0);

      each(targetOpportunties, (targetOpportuntiy) => {
        targetOpportuntiy.contactStatus = status;

        if (contacts.length) {
          const opportunityContacts = [];
          each(targetOpportuntiy.contact_roles, (cr) => {
            if (indexedByContactId[cr.contact_id]) {
              opportunityContacts.push({
                ...indexedByContactId[cr.contact_id],
                role: cr.role,
                is_primary: cr.is_primary,
              });
            }
          });
          targetOpportuntiy.contacts = opportunityContacts;
          const accountContacts = indexedByAccountId[targetOpportuntiy.account_id];
          targetOpportuntiy.account = { ...indexedAccounts[targetOpportuntiy.account_id], ...targetOpportuntiy.account };

          if (targetOpportuntiy.account) {
            targetOpportuntiy.account.contacts = accountContacts;
            targetOpportuntiy.account.indexedContacts = keyBy(accountContacts, 'contact_id');
          }
        }
      });

      const targetIndexedOpportunties = keyBy(targetOpportunties, 'opportunity_id');
      
      const opportunities = reduce(state.opportunities.opportunities, (items, opportunity) => {
        if (targetIndexedOpportunties[opportunity.opportunity_id]) {
          items.push(targetIndexedOpportunties[opportunity.opportunity_id]);
        } else {
          items.push(opportunity);
        }
        return items;
      }, []);

      const indexedOpportunities = {
        ...state.opportunities.indexedOpportunities,
        ...targetIndexedOpportunties,
      };

      return {
        ...state,
        opportunities: {
          ...state.opportunities,
          opportunities,
          indexedOpportunities,
          indexedContacts: {
            ...state.opportunities.indexedContacts,
            ...indexedByContactId,
          },
        },
      };
    }
    case DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_REQUESTED_FEEDBACK: {
      const { total, id } = action;
      const opportunities = reduce(state.opportunities.opportunities, (items, opportunity) => {
        if (opportunity.opportunity_id === id) {
          items.push({
            ...opportunity,
            requested_feedbacks: total,
          });
        } else {
          items.push(opportunity);
        }
        return items;
      }, []);
      const indexedOpportunities = reduce(state.opportunities.indexedOpportunities, (items, opportunity) => {
        items[opportunity.opportunity_id] = opportunity.opportunity_id === id ? {
          ...opportunity,
          requested_feedbacks: total,
        } : opportunity;
        return items;
      }, {});

      const savedOpportunities = reduce(state.savedParams.opportunities, (items, opportunity) => {
        items[opportunity.opportunity_id] = opportunity.opportunity_id === id ? {
          ...opportunity,
          requested_feedbacks: total,
        } : opportunity;
        return items;
      }, {});

      return {
        ...state,
        opportunities: {
          ...state.opportunities,
          opportunities,
          indexedOpportunities,
        },
        savedParams: {
          ...state.savedParams,
          opportunities: savedOpportunities,
        },
      };
    }
    default:
      return state;
  }
};

export const getOpportunities = state => state.winLossNomination.opportunities.opportunities;
export const getIndexedContacts = state => state.winLossNomination.opportunities.indexedContacts;
export const getIndexedOpportunities = state => state.winLossNomination.opportunities.indexedOpportunities;
export const getOpportunityLoading = state => state.winLossNomination.opportunities.status === 'loading';
export const getOpportunityLoaded = state => state.winLossNomination.opportunities.status === 'loaded';
export const getOpportunityHasErrors = state => state.winLossNomination.opportunities.status === 'error';
export const getOpportunityErrors = (state) => {
  if (state.winLossNomination.opportunities.status === 'error') {
    return state.winLossNomination.opportunities.errors;
  }
  return null;
};

export const getWinLossPrograms = state => state.winLossNomination.winLoss;
export const getWinLossProgram = (state, opportunityId) => {
  const { winLoss } = state.winLossNomination;
  return winLoss[opportunityId];
};
export const getWinLossEditingOpportunity = state => state.winLossNomination.winLossEditingOpportunity;
export const getWinLossEditingOpportunityEditingContact = (state) => {
  const winLossEditingOpportunity = getWinLossEditingOpportunity(state);
  if (winLossEditingOpportunity && winLossEditingOpportunity.editingContact) {
    return winLossEditingOpportunity.editingContact;
  }
  return null;
};
export const getSubmittedContacts = state => state.winLossNomination.contacts;
export const getWinLossProgramsMasterCheckboxStatus = (state) => {
  const { winLoss, opportunities } = state.winLossNomination;
  const selectedIds = [];
  const selectedSavedIds = [];
  each(winLoss, (wl, oId) => {
    selectedIds.push(oId);
    if (wl.is_saved) {
      selectedSavedIds.push(oId);
    }
  });
  const availableIds = [];
  const availableSavedIds = [];
  each(opportunities.indexedOpportunities, (o, oId) => {
    availableIds.push(oId);
    if (o.is_saved) {
      availableSavedIds.push(oId);
    }
  });

  const validSelectedIds = intersection(selectedIds, availableIds);
  const validSelectedSavedIds = intersection(selectedSavedIds, availableSavedIds);

  let allStatus = MASTER_CHECKBOX_STATUS.none;
  let savedStatus = MASTER_CHECKBOX_STATUS.none;

  if (validSelectedIds.length === 0) {
    allStatus = MASTER_CHECKBOX_STATUS.none;
  } else if (validSelectedIds.length === availableIds.length) {
    allStatus = MASTER_CHECKBOX_STATUS.full;
  } else {
    allStatus = MASTER_CHECKBOX_STATUS.partial;
  }

  if (validSelectedSavedIds.length === 0) {
    savedStatus = MASTER_CHECKBOX_STATUS.none;
  } else if (validSelectedSavedIds.length === availableSavedIds.length) {
    savedStatus = MASTER_CHECKBOX_STATUS.full;
  } else {
    savedStatus = MASTER_CHECKBOX_STATUS.partial;
  }

  return { allStatus, savedStatus };
};

export const getWinLossTrackings = (state) => {
  const { winLossTrackings } = state.winLossNomination;
  return winLossTrackings.trackings;
};
export const getWinLossTrackingsLoading = (state) => {
  const { winLossTrackings } = state.winLossNomination;
  return winLossTrackings.status === 'loading';
};
export const getWinLossTrackingsLoaded = (state) => {
  const { winLossTrackings } = state.winLossNomination;
  return winLossTrackings.status === 'loaded';
};
export const getWinLossTrackingsErrors = (state) => {
  if (state.winLossNomination.winLossTrackings.status === 'error') {
    return state.winLossNomination.winLossTrackings.errors;
  }
  return null;
};

export const getSavedParams = (state) => {
  const { savedParams } = state.winLossNomination;
  return savedParams ? savedParams.opportunities : {};
};

export const getSavedParamsLoading = (state) => {
  const { savedParams } = state.winLossNomination;
  return savedParams && savedParams.status === 'loading';
};
export const getSavedParamsLoaded = (state) => {
  const { savedParams } = state.winLossNomination;
  return savedParams && savedParams.status === 'loaded';
};
export const getTotalSaved = (state) => {
  const { savedParams } = state.winLossNomination;
  return savedParams ? savedParams.total : 0;
};

export const getUnlinkedContactLoading = (state) => {
  const { unlinkedContacts } = state.winLossNomination;
  return unlinkedContacts && unlinkedContacts.status === 'loading';
};
export const getUnlinkedContactLoaded = (state) => {
  const { unlinkedContacts } = state.winLossNomination;
  return unlinkedContacts && unlinkedContacts.status === 'loaded';
};
export const getUnlinkedContacts = (state) => {
  const { unlinkedContacts } = state.winLossNomination;
  return unlinkedContacts ? unlinkedContacts.contacts : [];
};

export const getSubmittedParams = (state, opportunityId) => {
  const { submittedParams } = state.winLossNomination;
  return submittedParams ? submittedParams.opportunities[opportunityId] || [] : [];
};

export const getWinLossSubmitParams = (state) => {
  let contactIds = [];
  let salesReps = [];
  let allSelectedProductIds = [];
  let invalidOpportunities = 0;
  let invalidSavedOpportunities = 0;

  const savedParams = [];
  let savedContactIds = [];
  let savedSalesReps = [];
  let savedSelectedProductIds = [];
  const selected = []; // all, include invalid
  const savedSelected = []; // all saved, include invalid

  const params = reduce(state.winLossNomination.winLoss, (opportunities, opportunity) => {
    const contactRoles = opportunity.contact_roles;
    const indexContactRoles = keyBy(contactRoles, 'contact_id');
    const { tracking } = opportunity;
    const isSaved = opportunity.is_saved === true;
    const selectedProductIds = opportunity.selected_product_ids;
    selected.push(opportunity);
    if (isSaved) {
      savedSelected.push(opportunity);
    }
    if (selectedProductIds && selectedProductIds.length && tracking && !tracking.allSubmitted) {
      const submittedContactIds = tracking.submittedContactIds || [];
      const contacts = reduce(opportunity.selected_contacts, (results, contact) => {
        // const ma = contact.mailing_address || {};
        const contactRole = indexContactRoles[contact.contact_id] || {};
        if (indexOf(submittedContactIds, contact.contact_id) < 0) {
          const newContact = cloneDeep(contact);
          newContact.is_primary = contactRole.is_primary || false;
          newContact.role = contactRole.role;
          contactIds.push(contact.contact_id);
          if (isSaved) {
            savedContactIds.push(contact.contact_id);
          }
          results.push(newContact);
        }
        return results;
      }, []);
      if (contacts.length) {
        // const closeDate = opportunity.close_date ? moment(opportunity.close_date) : null;
        const newOpportunity = cloneDeep(opportunity); // include account, owner, question, additional_information, outcome (stage)
        newOpportunity.selected_product_ids = selectedProductIds;
        newOpportunity.product = null; // get from FE when submmited
        newOpportunity.selected_contacts = contacts;

        delete newOpportunity.tracking;
        delete newOpportunity.is_saved;
        delete newOpportunity.logs;
        delete newOpportunity.contact_roles;
        delete newOpportunity.contacts;
        delete newOpportunity.line_items;
        delete newOpportunity.stage_histories;
        delete newOpportunity.submitted;
        delete newOpportunity.types;
        if (newOpportunity.account) {
          delete newOpportunity.account.contacts;
          delete newOpportunity.account.indexedContacts;
        }
        salesReps.push(opportunity.owner_id);
        allSelectedProductIds = allSelectedProductIds.concat(selectedProductIds);
        opportunities.push(newOpportunity);
        if (isSaved) {
          savedSalesReps.push(opportunity.owner_id);
          savedParams.push(newOpportunity);
          savedSelectedProductIds = savedSelectedProductIds.concat(selectedProductIds);
        }
      } else {
        invalidOpportunities += 1;
        if (isSaved) {
          invalidSavedOpportunities += 1;
        }
      }
    } else {
      invalidOpportunities += 1;
      if (isSaved) {
        invalidSavedOpportunities += 1;
      }
    }
    return opportunities;
  }, []);
  contactIds = uniq(contactIds);
  salesReps = uniq(salesReps);
  allSelectedProductIds = uniq(allSelectedProductIds);

  savedContactIds = uniq(savedContactIds);
  savedSalesReps = uniq(savedSalesReps);
  savedSelectedProductIds = uniq(savedSelectedProductIds);
  return {
    params,
    savedParams,
    stats: {
      contacts: contactIds,
      salesReps,
      selectedProductIds: allSelectedProductIds,
      invalidOpportunities,
      selected,
    },
    savedStats: {
      contacts: savedContactIds,
      salesReps: savedSalesReps,
      selectedProductIds: savedSelectedProductIds,
      invalidOpportunities: invalidSavedOpportunities,
      selected: savedSelected,
    },
  };
};

export const getAvailableContacts = (opportunity, selectedContacts) => {
  // return avaialbel contacts in opp and opp account
  const { account, contacts, tracking } = opportunity;
  const submittedContactIds = tracking ? tracking.submittedContactIds : [];
  const selectedContactIds = selectedContacts ? map(selectedContacts, 'contact_id') : [];

  const oppContactIds = map(contacts || [], 'contact_id');
  const accContactIds = map(account && account.contacts ? account.contacts : [], 'contact_id');


  const unavailableContactIds = union(selectedContactIds, submittedContactIds);

  const oppAvailableContactIds = difference(oppContactIds, unavailableContactIds);
  const accAvailableContactIds = difference(accContactIds, unavailableContactIds.concat(oppContactIds));

  const oppCount = oppAvailableContactIds.length;
  const accCount = accAvailableContactIds.length;

  return {
    opportunity: oppCount,
    account: accCount,
  };
};


export default WinLossReducer;
